import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/atoms/sheet';
import { ContactBillToFormBody } from '@/components/organisms/contacts/ContactBillToFormBody';
import type { BillTo, Contact } from '@/types/contact';

/**
 * In-context slide-over for adding/editing a bill-to relationship — the
 * "medium" tier of the form system. Reuses {@link ContactBillToFormBody}.
 */
export function ContactBillToFormSheet({
  open,
  onOpenChange,
  mode,
  contactId,
  currentContact,
  billTo,
  entriesCount,
  isLoading,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: 'create' | 'edit';
  contactId: string;
  currentContact?: Contact | null;
  billTo?: BillTo | null;
  entriesCount?: number;
  isLoading?: boolean;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-xl">
        <SheetHeader className="shrink-0 border-b bg-background px-4 py-3">
          <SheetTitle>{mode === 'edit' ? 'Edit bill to' : 'New bill to'}</SheetTitle>
        </SheetHeader>
        <ContactBillToFormBody
          mode={mode}
          contactId={contactId}
          currentContact={currentContact}
          billTo={billTo}
          entriesCount={entriesCount}
          isLoading={isLoading}
          onCancel={() => onOpenChange(false)}
          onSaved={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
